import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {ApiResultDispatcherService} from "../api/api-result-dispatcher.service";
import {ApiService} from "../api/api-service";

@Injectable({
    providedIn: "root"
})
export class WishListService {
    private API_BASE_URL = "/nop/quickshop";

    private API_ADD_TO_WISH_LIST_URL = `${this.API_BASE_URL}/wishlist/add`;
    private API_REMOVE_FROM_WISH_LIST_URL = `${this.API_BASE_URL}/wishlist/remove`;

    public constructor(
        private http: HttpClient,
        private apiService: ApiService,
        private apiDispatcherService: ApiResultDispatcherService
    ) {
    }

    public addToWishList(productId: number): Observable<boolean> {
        const http = this.apiService.executePost<boolean>(
            `${this.API_ADD_TO_WISH_LIST_URL}`,
            productId
        );

        const result = this.apiDispatcherService.dispatchErrorsAndUnwrapResult(http);

        return result;
    }

    public removeFromWishList(productId: number): Observable<boolean> {
        const http = this.apiService.executePost<boolean>(
            `${this.API_REMOVE_FROM_WISH_LIST_URL}`,
            productId
        );

        const result = this.apiDispatcherService.dispatchErrorsAndUnwrapResult(http);

        return result;
    }
}
